import {
  INPUT_CONTAINER_STYLE,
  INPUT_NON_FLOATING_PLACEHOLDER_STYLE,
  INPUT_STYLE,
} from './Input.content';

export const getInputContainerStyle = (
  error = '',
  focused = false,
  disabled = false,
) => ({
  ...INPUT_CONTAINER_STYLE.default,
  ...(error && INPUT_CONTAINER_STYLE.error),
  ...(focused && INPUT_CONTAINER_STYLE.focused),
  ...(disabled && INPUT_CONTAINER_STYLE.disabled),
});

export const getInputStyle = (
  disabled = false,
  isPlaceholderFloating = false,
) => ({
  ...INPUT_STYLE.default,
  ...(disabled && INPUT_STYLE.disabled),
  ...(!isPlaceholderFloating && INPUT_NON_FLOATING_PLACEHOLDER_STYLE),
});
